import Form from './components/form_controller';

export default class NotificationFiltersController extends Form {
  dropdownIds = ['per_page', 'type'];
}
